import styled, { css } from 'styled-components'
import tw from 'twin.macro'

export const styledIconWrapperStyles = css`
  ${tw`mr-1`}
`
export const styledRemarkTextStyles = css`
  ${tw`text-xs leading-4 font-medium text-lightAmber700`}
`
